import { Link } from "react-router-dom";
import SocialIcons from "./SocialIcons";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const Footer = () => {
  const { data: settings } = useSiteSettings();

  // Get copyright year range
  const currentYear = new Date().getFullYear();
  const startYear = settings?.copyright_start_year || currentYear;
  const copyrightYear =
    startYear === currentYear ? currentYear : `${startYear}-${currentYear}`;

  return (
    <footer className="w-full bg-gradient-to-r from-teedee-blue via-bobo-green to-brand-purple text-white">
      <div className="w-full py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            {/* Logo & Description */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <img
                  src="/img/bobo-teedee-logo.png"
                  alt="Bobo & Teedee®"
                  className="h-14 w-auto"
                />
                <span className="text-3xl font-bold">
                  {settings?.site_title || "Bobo & Teedee®"}
                </span>
              </div>
              <p className="text-lg lg:text-xl mb-6 max-w-md leading-relaxed">
                {settings?.site_description ||
                  "Educational adventures from the Cayman Islands, teaching children about culture, values, and friendship through fun storytelling."}
              </p>
              <SocialIcons />
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xl font-semibold mb-6">Quick Links</h3>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/episodes"
                    className="text-lg hover:text-golden-orange transition-colors"
                  >
                    Episodes
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-lg hover:text-golden-orange transition-colors"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/culture"
                    className="text-lg hover:text-golden-orange transition-colors"
                  >
                    Cayman Culture
                  </Link>
                </li>
                <li>
                  <Link
                    to="/activities"
                    className="text-lg hover:text-golden-orange transition-colors"
                  >
                    Kids' Corner
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal & Partners */}
            <div>
              <h3 className="text-xl font-semibold mb-6">More</h3>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/partners"
                    className="text-lg hover:text-golden-orange transition-colors"
                  >
                    Our Partners
                  </Link>
                </li>
                <li>
                  <Link
                    to="/support"
                    className="text-lg hover:text-golden-orange transition-colors"
                  >
                    Support Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-lg hover:text-golden-orange transition-colors"
                  >
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/legal/terms"
                    className="text-lg hover:text-golden-orange transition-colors"
                  >
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link
                    to="/legal/privacy"
                    className="text-lg hover:text-golden-orange transition-colors"
                  >
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-white/20 mt-12 pt-8 text-center">
            <p className="text-xl">
              © {copyrightYear} {settings?.site_title || "Bobo & Teedee®"}.
              All rights reserved.
            </p>
            <p className="text-base mt-3 opacity-90">
              Proudly created in the Cayman Islands 🇰🇾
            </p>
            <div className="mt-4 flex justify-center items-center">
              <p className="text-sm opacity-80 mr-2">Powered by</p>
              <img
                src="/img/indatsys-wh-logo.svg"
                alt="INDATSYS"
                className="h-5 opacity-90 hover:opacity-100 transition-opacity mx-2"
              />
              <img
                src="/img/sands-wh-logo.png"
                alt="SANDS LTD"
                className="h-9 opacity-90 hover:opacity-100 transition-opacity ml-2"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
